<template>
  <CustomerAccountLayout
    :nav-items="navigationItems"
    nav-aria-label="Account navigation"
    mobile-nav-title="Meine Basler ID"
    :logout-link="logoutLink"
  >
    <template #content>
      <slot />
    </template>
  </CustomerAccountLayout>
</template>

<script setup lang="ts">
import {
  CustomerAccountLayout,
  type LogoutLinkInterface
} from '@hypercodestudio/basler-components';
import { useAccountNavigation } from '~/composables/useAccountNavigation';
import buildAuthLogoutUri from '~/utils/buildAuthLogoutUri';

const route = useRoute();
const { $contentfulPagePayload, $textDictionary } = useNuxtApp();
const { getNavigationItems } = useAccountNavigation();

const navigationItems = computed(() =>
  getNavigationItems(
    $contentfulPagePayload.value?.secondaryNavigation?.fields?.navigationItems,
    route.path
  )
);

const logoutLink = computed<LogoutLinkInterface>(() => ({
  link: {
    uri: buildAuthLogoutUri(),
    target: '_self',
    external: true
  },
  text:
    $textDictionary.value?.['pageHeader.loginQuickView.actions.logout.label'] ??
    'Logout'
}));
</script>

<style scoped>
:deep(.customer-account-layout__content > .contentful-route-content) {
  display: flex;
  flex-direction: column;
  gap: var(--customer-account-layout-content-gap);
}

:deep(.customer-account-layout__content > .contentful-route-content > *) {
  width: 100%;
}
</style>
